import { idmsApi } from "./api";
import { API_DEALER_ENDPOINT } from "../../constants/endpoints";
import { convertObjectToQueryParams } from "../../util/convertObjectToQueryParams";
import type { DealerDetailsResponse } from "../../target-manager/models/dealer-details";
import type { DealerSubscriptionHistoryDto } from "../../target-manager/models/dealer-subscription";

const dealerApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealers: builder.query<any, GetDealership>({
      query: (getDealerships) =>
        `${API_DEALER_ENDPOINT}?${convertObjectToQueryParams(
            getDealerships
        )}`,
    }),

    // New: direct SQL-backed dealers endpoint (I hate stored procedures)
    getDealersDirect: builder.query<any, GetDealership>({
      query: (getDealerships) =>
        `${API_DEALER_ENDPOINT}/query?${convertObjectToQueryParams(
          getDealerships
        )}`,
    }),

    getDmsList: builder.query<any, void>({
        query: () => API_DEALER_ENDPOINT + "/Dms",
    }),

    assignProduct: builder.mutation<any, DealerAssignProductV2>({
        query: (request) => ({
          url: API_DEALER_ENDPOINT + "/assignProduct",
          method: "POST",
          body: request,
        }),
    }),
    unAssignProduct: builder.mutation<any, DealerUnAssignProductV2>({
      query: (request) => ({
        url: API_DEALER_ENDPOINT + "/UnAssignProduct",
        method: "POST",
        body: request,
      }),
    }),
    getDealersByProduct: builder.query<any, string>({
      query: (productId) => `${API_DEALER_ENDPOINT}/${productId}`,
    }),

    // Total dealers added within the last N days (requires backend support)
    getDealersAddedSince: builder.query<{ count: number }, number>({
      // arg = days
      query: (days) => `${API_DEALER_ENDPOINT}/added-since?days=${days}`,
    }),

    // Recent onboarding activity: Assign (onboard) and Change (tier change)
    getDealerOnboardingActivity: builder.query<any[], number>({
      // arg = days
      query: (days) => `${API_DEALER_ENDPOINT}/onboarding-activity?days=${days}`,
    }),

    // New endpoints for dealer details and subscription history
    getDealerDetails: builder.query<DealerDetailsResponse, number>({
      query: (dealerId) => `${API_DEALER_ENDPOINT}/${dealerId}/details`,
    }),
    getDealerSubscriptionHistory: builder.query<DealerSubscriptionHistoryDto[], number>({
      query: (dealerId) => `${API_DEALER_ENDPOINT}/${dealerId}/subscription-history`,
    }),

    // Locations under a dealer's DMS Dealer ID
    getDealerLocations: builder.query<DealerLocationDto[], number>({
      query: (dealerId) => `${API_DEALER_ENDPOINT}/${dealerId}/locations`,
    }),

    // Distribution of dealers by location count
    getDealerLocationDistribution: builder.query<DealerLocationDistributionDto[], void>({
      query: () => `${API_DEALER_ENDPOINT}/location-distribution`,
    }),
  }),
});

export const {
  useGetDealersQuery,
  useGetDealersDirectQuery,
  useGetDmsListQuery,
  useAssignProductMutation,
  useUnAssignProductMutation,
  useGetDealersByProductQuery,
  useGetDealerDetailsQuery,
  useGetDealerSubscriptionHistoryQuery
  , useGetDealerLocationsQuery
  , useGetDealersAddedSinceQuery
  , useGetDealerOnboardingActivityQuery
  , useGetDealerLocationDistributionQuery
} = dealerApi;

